export enum DisabledModals {
  RAC = 'RAC',
  PE = 'PE',
  ALI = 'ALI',
  LENDER = 'Lender',
  UNLOCK_INVENTORY = 'UNLOCK_INVENTORY',
  REHASH_CALCULATOR = 'REHASH_CALCULATOR',
}
